<template>
    <div class="node-area-back" v-if="color" :class="`${color} lighten-5`" />
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, initEmploymentField } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initEmploymentField },

        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
    },
    data: () => ({
        EMPLOYMENT_FIELD_SIDES,
    }),
    computed: {
        color() {
            switch (this.mode) {
                case "done": {
                    return;
                }
                case "view": {
                    if (this.value.side == EMPLOYMENT_FIELD_SIDES.DOCUMENT.value) return;
                    if (!this.value.isRequired) return;
                    break;
                }
                case "sign": {
                    if (this.value.side == EMPLOYMENT_FIELD_SIDES.DOCUMENT.value) return;
                    if (!this.value.isRequired) return;
                    break;
                }
                case "form": {
                    if (this.value.side != EMPLOYMENT_FIELD_SIDES.DOCUMENT.value && !this.value.isRequired) return;
                    break;
                }
            }
            return EMPLOYMENT_FIELD_SIDES[this.value.side]?.color;
        },
    },
};
</script>

<style lang="scss" scoped>
.node-area-back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    z-index: -1;
}
</style>
